import LoginApi from "./LoginApi";
import { _24RENT_API_KEY } from "../apiKeys";

class V3LoginApi implements LoginApi {
  fetchCustom: (
    url: string,
    options?: any,
    token?: boolean
  ) => Promise<any>;

  constructor(
    fetchC: (
      url: string,
      options?: any,
      token?: boolean
    ) => Promise<any>
  ) {
    this.fetchCustom = fetchC;
  }

  convertAuthHashToToken = (
    authenticationHash: string,
    reservationId?: number,
    customerId?: number
  ): Promise<any> => {
    // console.log(
    //   "V3ApiService - convertAuthHashToToken: ",
    //   customerId,
    //   authenticationHash
    // );
    if (authenticationHash === '' || (authenticationHash.length !== 48 && authenticationHash.length !== 80)) {
      return new Promise((res, rej) => rej(`Auth hash incorrect length: ${authenticationHash.length} chars (should be 48 or 80)`));
    }

    const cIdString = customerId ? customerId.toString() : "0";
    const cId = parseInt(cIdString)

    return this.fetchCustom(
      "/login/try-authentication-hash",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          reservationId: reservationId === -1 ? undefined : reservationId,
          customerId: cId,
          authenticationHash
        })
      },
      false
    );
  };

  getPIN = (phoneNumber: string) => {
    return this.fetchCustom(
      "/login/send-2fa-pin",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber })
      },
    );
  };

  sendAutoLink = (phoneNumber: string) => {
    return this.fetchCustom(
      "/login/send-auth-email",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber })
      },
    );
  };

  tryPIN = (pin: string, phoneNumber: string) => {
    return this.fetchCustom(
      "/login/try-2fa-pin",
      {
        method: "POST",
        body: JSON.stringify({ phoneNumber, pin })
      },
    );
  };

  getFrontEndLink = () => {
    return new Promise((resolve, reject) => {
      reject("V3ApiService.getFrontEndLink() not yet implemented!");
    });
  };
}

export default V3LoginApi;
